import { t } from 'i18next';
import { COMMON_TRANSLATE_KEYS } from '../constants/translate-keys';

const languageKey = 'i18nextLng';

export const getLanguage = () => {
  return localStorage.getItem(languageKey) || 'en';
};

export const getObjectTranslation = (item: any, language: string) => {
  return language === 'bg' ? item.nameBg : item.name;
};

export const getWeekDayFromNumber = (day: number, short: boolean = false) => {
  if (!short) {
    return [
      t(COMMON_TRANSLATE_KEYS.SUNDAY_NORMAL),
      t(COMMON_TRANSLATE_KEYS.MONDAY_NORMAL),
      t(COMMON_TRANSLATE_KEYS.TUESDAY_NORMAL),
      t(COMMON_TRANSLATE_KEYS.WEDNESDAY_NORMAL),
      t(COMMON_TRANSLATE_KEYS.THURSDAY_NORMAL),
      t(COMMON_TRANSLATE_KEYS.FRIDAY_NORMAL),
      t(COMMON_TRANSLATE_KEYS.SATURDAY_NORMAL),
    ][day];
  } else {
    return [
      t(COMMON_TRANSLATE_KEYS.SUNDAY_SHORT),
      t(COMMON_TRANSLATE_KEYS.MONDAY_SHORT),
      t(COMMON_TRANSLATE_KEYS.TUESDAY_SHORT),
      t(COMMON_TRANSLATE_KEYS.WEDNESDAY_SHORT),
      t(COMMON_TRANSLATE_KEYS.THURSDAY_SHORT),
      t(COMMON_TRANSLATE_KEYS.FRIDAY_SHORT),
      t(COMMON_TRANSLATE_KEYS.SATURDAY_SHORT),
    ][day];
  }
};
